import { FormControl, FormLabel, Switch } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface QuestionKnockoutSwitchProps {
  onChange: (value: boolean) => void;
  checked: boolean;
}

export default function QuestionKnockoutSwitch({ onChange, checked }: QuestionKnockoutSwitchProps) {
  const { t } = useTranslation('createJobPosition');

  return (
    <FormControl display="flex" alignItems="center">
      <Switch
        id="position-question-knockout"
        onChange={(e) => onChange(e.target.checked)}
        isChecked={checked}
        data-testid="Knockout-question"
        size="sm"
      />
      <FormLabel htmlFor="position-question-knockout" mb="0" ml={2} colorScheme="gray">
        {t('questionAutoDismissLabel')}
      </FormLabel>
    </FormControl>
  );
}
